<template>
    <div id="image-layout" style="background-color: white; height: -webkit-fill-available;">
        <!--
        <div id="frame" style="background-color: white; position:relative;" :class="['frame-margin']">
            <div style="display: block; height: 100%; text-align: center;">
                <img src="../../../static/img/products/frigo.jpg"
                alt="Nodo catalogo"
                style="width: 70%; height: auto;">
            </div> 
        </div>
        -->
        <viewer-container :activeData="activeData" :focus="focus" @pointedSelection="executeOnPointedSelection()"></viewer-container>
    </div>
</template> 

<script>
import ViewerContainer from "./ViewerContainer.vue";
import { eventBus } from "../../eventbus";

export default {
  props: {
    activeData: Object,
    focus: String
  },
  components: {
    ViewerContainer
  },
  mounted: function() {
    if (this.activeData) {
      this.assignData();
      this.$nextTick(function(){
        this.setHeight()
      })
      
    }
  },
  created: function(){
    var vm = this;
    eventBus.$on("heightMutation", function(){
      vm.show = false;
      vm.setHeight();
    })
  },
  data: function() {
    return {
      arrayToTable: []
    };
  },
  watch: {
    activeData: function() {
      this.assignData();
    }
  },
  methods: {
    setHeight: function(){
      var adjust_size = this.$root.WINDOW_HEIGHT - 60;
      $('.table-resize-adjust').css('max-height', adjust_size + 'px');
      $('.table-resize-adjust').css('min-height', adjust_size + 'px');
      $('.table-resize-adjust').css('height', adjust_size + 'px');
    },
    assignData: function() {
      this.arrayToTable = this.activeData.children;
    },
    executeOnPointedSelection: function(){
      if(this.$Behaviors.hotspotLoadLinkedNode){
        try {
          var ref = this.$route.params.focus;
          if(ref != null){
            var ind = -1;
            this.activeData.children.some(function(child, index){
              if(child[this.$Behaviors.focusBy()] == ref){
                ind = index;
                return true;
              }
              return false;
            }, this)
            if(ind != -1){
              var target = this.activeData.children[ind];
              if(target.cco && target.cco > 0){
                this.$root.navigateTo(target.sid, target.fid)
              }
            } 
          } 
        } catch(err){
          console.log(err)
        }
      }
    }
  }
};
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/components/sub-views/Image.vue?df9cc788